import { useEffect, useRef, useState } from 'react'
import ClickAwayListener from '@mui/base/ClickAwayListener'
import './input.css'
// import { MuiPickersUtilsProvider, KeyboardTimePicker, } from '@mui/D'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
// import MomentUtils from '@date-io/moment'
import moment from "moment-jalaali"
import DatePicker from "@mui/lab/DatePicker"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import {commaFormat} from '../../scripts/helper'
import { ExpandMore } from '@mui/icons-material'
const Input = ({ 
    inputField: { value, type = 'text', placeholder, items, icon, name, label, suffix, desc, require, isMoney, minDate = ''}, 
    onClickDropdownItem, onChange, clickSuffix, onClick, children, className, readOnly, onKeyDown, focused = false, handleBlur
}) => {

    const [showDropdown, setShowDropdown] = useState(false)
    const [openTimePicker, setOpenTimePicker] = useState(false)
    const [selectDate] = useState('')
    const [isFocus, setFocus] = useState(focused)
    const ref = useRef(null)

    useEffect( () => {
        focusOnInput(focused)
    }, [focused])

    const focusOnInput = (focused) => {

        if(focused === true) {
            ref.current.focus()
        }
    }

    const handleClickDropdownItem = (data, label) => {
        onClickDropdownItem(data, label)
        setShowDropdown(false)
    }

    const handleClickTime = time => {

        onChange(moment(time).format('HH:mm'), name)
        setOpenTimePicker(false)

    }

    const handleChangeDatepicker = dateObj => {

        const { day, year, month} = dateObj

        onChange(`${year}/${month}/${day}`, name)

    }

    const custonDatepickerInput = ({ ref }) =>
        <div className="input-box__input" style={{width: '100%'}}>
            {icon && <i className=""></i>}
            <input
                ref={ref}
                value={value}
                type="text"
                placeholder={placeholder}
                name={name}
                onClick={() => setOpenTimePicker(true)}
                onChange={e => onChange(e.target.value, name)}
                readOnly
            />
            {suffix && <span>{suffix}</span>}
        </div>

    const passwordInput = () =>
        <div className="input-box__input">
            {icon && <div className="icon">{icon}</div>}
            <input
                value={value}
                placeholder={placeholder}
                name={name}
                type='password'
                onChange={e => onChange(e.target.value, name)}
                onKeyDown={onKeyDown && (e => onKeyDown(e))}
                ref={ref}
            />
            {suffix && <div className="suffix" onClick={clickSuffix}>{suffix}</div>}
        </div>

    const textInput = () =>
        <div className="input-box__input">
            {icon && <div className="icon">{icon}</div>}
            <input
                value={isMoney ? (value ? commaFormat(value): '') : value}
                placeholder={placeholder}
                name={name}
                type={type}
                onChange={e => onChange(e.target.value, name)}
                readOnly={readOnly}
                onKeyDown={onKeyDown && (e => onKeyDown(e))}
                ref={ref}
                onBlur={handleBlur}
            />
            {suffix && <div className="suffix" onClick={clickSuffix}>{suffix}</div>}
        </div>

    const numberInput = () => 
        <div className="input-box__input">
            {icon && <div className="icon">{icon}</div>}
            <input
                value={value}
                placeholder={placeholder}
                name={name}
                type={type}
                onChange={e => onChange(e.target.value, name)}
                onKeyDown={onKeyDown && (e => onKeyDown(e))}
                ref={ref}
            />
            {suffix && <div className="suffix" onClick={clickSuffix}>{suffix}</div>}
        </div>
    
    const textareaInput = () =>
        <div className="input-box__input">
            {icon && <i className=""></i>}
            <textarea
                value={value}
                placeholder={placeholder}
                rows="3"
                name={name}
                onChange={e => onChange(e.target.value, name)}
                readOnly={readOnly}
                ref={ref}

            />
            {suffix && <span>{suffix}</span>}
        </div>

    const selectInput = () => 
        <>
            {onClick ? 
                <div className="input-box__input disabled" onClick={onClick}>
                {icon && <div className="icon">{icon}</div>}    
                    <input
                        value={value || ''}
                        placeholder={placeholder}
                        name={name}
                        type={type}
                        readOnly
                        ref={ref}
                    />
                    <div className="suffix"><i className="icon-Arrow---Bottom-1"><ExpandMore/></i></div>
                </div> :
                <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
                    <div className="input-box__input" onMouseDown={() => setShowDropdown(true)}>
                    {icon && <div className="icon">{icon}</div>}    
                        <input
                            value={value || ''}
                            placeholder={placeholder}
                            name={name}
                            type={type}
                            readOnly
                            onChange={e => onChange(e.target.value, name)}
                            ref={ref}
                        />
                        {
                           
                           !readOnly &&

                           <>
                            <div className="suffix"><i className="icon-Arrow---Bottom-1"></i><ExpandMore/></div>
                            <div className={"dropdown" + (showDropdown ? ' show' : '')}>
                                {children ? 
                                    children :
                                    <>
                                        {items.map(item =>
                                            <div
                                                className="dropdown__item"
                                                key={item.id}
                                                onClick={() => handleClickDropdownItem(item.data, item.label)}
                                            >{item.label}</div>
                                        )}
                                        {items.length === 0 && <div className="empty">No Options</div>}
                                    </>
                                }
                            </div>
                           </>
                        }

                    </div>
                </ClickAwayListener>
            }
        </>

    const timeInput = () => 
        <>
            <LocalizationProvider dateAdaper={AdapterDateFns}>
                {/* <KeyboardTimePicker
                    okLabel="ثبت"
                    cancelLabel="انصراف"
                    margin="normal"
                    id="time-picker"
                    label="Time picker"
                    value={null}
                    ampm={false}
                    open={openTimePicker}
                    onChange={handleClickTime}
                    onClose={() => setOpenTimePicker(false)}
                /> */}
            </LocalizationProvider>

            <div className="input-box__input">
                {icon && <i className=""></i>}
                <input
                    value={value}
                    type="text"
                    placeholder={placeholder}
                    name={name}
                    onClick={() => setOpenTimePicker(true)}
                    onChange={e => onChange(e.target.value, name)}
                    readOnly
                />
                {suffix && <span>{suffix}</span>}
            </div>
        </>

    const dateInput = () =>
        <DatePicker
            value={selectDate}
            onChange={handleChangeDatepicker}
            renderInput={custonDatepickerInput}
            shouldHighlightWeekends
            minimumDate={minDate}
            locale="fa"
        />  

    return (
        <div className={`input-box ${className}`}>
            {label && <div className="input-box__label">{label}{require && '*'}</div>}
           
            {type === 'number' && numberInput()}
            {type === 'textarea' && textareaInput()}
            {type === 'select' && selectInput()}
            {type === 'text' && textInput()}
            {type === 'password' && passwordInput()}
            {type === 'timepicker' && timeInput()}
            {type === 'datepicker' && dateInput()}
       
            {desc && <div className="input-box__desc">{desc}</div>}
        </div>
    )
}

export default Input